import { IApplication } from '@/typings';

import { adaptApplicationFormStatusResponseToApplicationStatus } from '.';
import { adaptAttestationFieldSummaryResponseToApplicationAttestationSummary } from '../attestation';
import { adaptDecimalValueToPercentage } from '../utilities';
import { ApplicationResponseDTO } from '@/api/application/DTOs';

export const adaptApplicationResponseToApplication = (
  applicationResponse: ApplicationResponseDTO,
): IApplication => {
  const completedSections = applicationResponse.sections.reduce(
    (accumulator, section) => {
      return adaptDecimalValueToPercentage(
        section.fieldsSummary?.completedPercentage ?? 0,
      ) === 100
        ? accumulator + 1
        : accumulator;
    },
    0,
  );

  return {
    id: applicationResponse.id,
    name: applicationResponse.name,
    stateCode: applicationResponse.stateCode,
    clientName: applicationResponse.clientName,
    providerName: applicationResponse.providerName,
    completedPercentage: adaptDecimalValueToPercentage(
      applicationResponse.completedPercentage,
    ),
    attestationSummary:
      adaptAttestationFieldSummaryResponseToApplicationAttestationSummary(
        applicationResponse.attestationSummary,
      ),
    releaseCompletedDate: applicationResponse.releaseCompletedDate,
    signatureNameCompleted: applicationResponse.signatureNameCompleted,
    providerAuthorizedDate: applicationResponse.providerAuthorizedDate,
    providerReviewedDate: applicationResponse.providerReviewedDate,
    submittedToGeminiDate: applicationResponse.submittedToGeminiDate,
    verificationStartedDate: applicationResponse.verificationStartedDate,
    verifiedDate: applicationResponse.verifiedDate,
    status: adaptApplicationFormStatusResponseToApplicationStatus(
      applicationResponse.status,
    ),
    statusDescription: applicationResponse.statusDescription,
    sectionsIds: applicationResponse.sections.map(
      section => section.applicationFormSectionID,
    ),
    completedSections,
  };
};
